import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../../components/Logo";
import ProgressSteps from "../../../components/ProgressSteps";

export default function EtablissementSignupSuccess() {
  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state as { mode?: "claim" | "creation" } | null;
  const mode = state?.mode === "claim" ? "claim" : "creation";
  const total = mode === "claim" ? 3 : 5;

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 relative">
      {/* Mobile background image */}
      <div className="absolute inset-0 md:hidden">
        <img src={'/maps-login-side.jpg'} alt="signup-success" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/30" />
      </div>

      {/* Left: content */}
      <div className="relative flex items-center justify-center px-4 md:px-10 py-10">
        <div className="w-full max-w-md">
          <div className="flex justify-center"><Logo size={56} /></div>
          <div className="mt-6 text-sm" style={{ color: "#00553E" }}>
            <Link to="/etablissement/connexion">← Retour</Link>
          </div>
          <h1 className="mt-2 text-2xl md:text-3xl font-semibold text-[#0B1F16]">Créer le compte de l'établissement</h1>
          <div className="mt-4 text-xl font-semibold text-[#0B1F16]">
            Votre compte a été créé avec succès !
          </div>
          <p className="mt-2 text-sm" style={{ color: "#00553E" }}>
            Connectez-vous dès maintenant pour transmettre vos documents et faire valider votre établissement.
          </p>
          <div className="mt-12">
            <ProgressSteps step={total} total={total} />
          </div>
          <div className="mt-6">
            <button
              type="button"
              onClick={() =>
                navigate("/etablissement/connexion", {
                  state: {
                    message:
                      "Compte créé avec succès. Connectez-vous pour transmettre vos documents depuis « Vérification d'identité ».",
                  },
                })
              }
              className="w-full h-12 rounded-[10px] font-semibold text-white cursor-pointer"
              style={{ background: "#00553E" }}
            >
              Retour à la connexion
            </button>
          </div>
          <p className="mt-4 text-sm text-gray-600">
            Une fois connecté, retrouvez le menu « Vérification d&apos;identité » dans votre tableau de bord pour
            soumettre la carte CIP du responsable et l&apos;arrêté ministériel.
          </p>
        </div>
      </div>

      {/* Right: image (desktop) */}
      <div className="relative hidden md:block">
        <img src={'/maps-login-side.jpg'} alt="signup-success" className="absolute inset-0 w-full h-full object-cover" />
      </div>
    </div>
  );
}
